<template>
  <div class="box">
    <div class="heading">{{ $t("guests.total") }}</div>
    <div class="title has-text-weight-bold">{{ total }}</div>

    <div class="level is-mobile has-text-centered">
      <div class="level-item">
        <div>
          <div class="heading">{{ $t("guests.new") }}</div>
          <div class="title is-5 has-text-weight-bold">
            {{ newVisitorsCount }}
          </div>
        </div>
      </div>

      <div class="level-item">
        <div>
          <div class="heading">{{ $t("guests.returning") }}</div>
          <div class="title is-5 has-text-weight-bold">
            {{ returningVisitorsCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      count: new window.RemoteData("/admin/api/web/analytics/user-types"),
    };
  },

  computed: {
    total() {
      return _.sumBy(this.count.data, "sessions");
    },

    newVisitorsCount() {
      let item = _.find(this.count.data, { type: "New Visitor" });

      return item ? item.sessions : 0;
    },

    returningVisitorsCount() {
      let item = _.find(this.count.data, { type: "Returning Visitor" });

      return item ? item.sessions : 0;
    },
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    },
  },

  methods: {
    load() {
      this.count.with({ date_range: this.$route.query.date_range }).load();
    },
  },
};
</script>
